/**
 * Module-level registry to coordinate batch vs individual player data fetching.
 * 
 * When `useOptimizedPlayerBatch` handles a set of UUIDs, it registers them here
 * SYNCHRONOUSLY before starting the async batch fetch. Individual hooks
 * (`usePlayerName`, `usePlayerAvatar`) check this registry and skip their own
 * fetch when the UUID is batch-managed, avoiding duplicate network requests.
 * 
 * After the batch completes (success or failure), UUIDs are unregistered so
 * individual hooks can fall back to their own fetch if needed.
 */

const batchManagedUuids = new Set<string>();

export const registerForBatch = (uuids: string[]) => {
  for (const uuid of uuids) {
    batchManagedUuids.add(uuid);
  }
};

export const unregisterFromBatch = (uuids: string[]) => {
  for (const uuid of uuids) {
    batchManagedUuids.delete(uuid);
  }
};

export const isBatchManaged = (uuid: string): boolean => {
  return batchManagedUuids.has(uuid);
};
